import {combine} from 'effector';
import {createGate} from 'effector-react';

import {
    assignAppeal,
    fetchAppealCard,
    fetchAppealThemes,
    fetchNkEmployees,
    rejectAppeal,
    resolveAppeal,
    takeAppeal,
    uploadAppealResponsePhotos,
} from 'api';
import {rootDomain} from 'core/rootDomain';
import {AppealAssignRequest, AppealCard, AppealTheme, NkEmployee} from 'types';

const domain = rootDomain.createDomain('complaintDetailDomain');

export const Gate = createGate<{
    id: number;
    canViewPersonnel: boolean;
}>('ComplaintDetailGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchAppealCardFx',
    handler: fetchAppealCard,
});
export const takeAppealFx = domain.createEffect({name: 'takeAppealFx', handler: takeAppeal});
export const resolveAppealFx = domain.createEffect({
    name: 'resolveAppealFx',
    handler: resolveAppeal,
});
export const rejectAppealFx = domain.createEffect({name: 'rejectAppealFx', handler: rejectAppeal});
export const assignAppealFx = domain.createEffect({name: 'assignAppealFx', handler: assignAppeal});
export const fetchEmployeesFx = domain.createEffect({
    name: 'fetchComplaintEmployeesFx',
    handler: fetchNkEmployees,
});
export const fetchThemesFx = domain.createEffect({
    name: 'fetchComplaintThemesFx',
    handler: fetchAppealThemes,
});
export const uploadResponsePhotosFx = domain.createEffect({
    name: 'uploadAppealResponsePhotosFx',
    handler: uploadAppealResponsePhotos,
});

export const takeRequested = domain.createEvent<string>();
export const resolveRequested = domain.createEvent<string>();
export const rejectRequested = domain.createEvent<string>();
export const assignRequested = domain.createEvent<AppealAssignRequest>();
export const responsePhotosSelected = domain.createEvent<File[]>();
export const setEmployees = domain.createEvent<NkEmployee[]>();

export const data$ = domain.createStore<AppealCard | null>(null);
export const employees$ = domain.createStore<NkEmployee[]>([]);
export const themes$ = domain.createStore<AppealTheme[]>([]);
export const error$ = domain.createStore<Error | null>(null);

export const actionPending$ = combine(
    takeAppealFx.pending,
    resolveAppealFx.pending,
    rejectAppealFx.pending,
    assignAppealFx.pending,
    uploadResponsePhotosFx.pending,
    (...pending) => pending.some(Boolean),
);

export const detailState$ = combine({
    data: data$,
    employees: employees$,
    themes: themes$,
    error: error$,
    isLoading: fetchDataFx.pending,
    actionPending: actionPending$,
});
